import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form, InputGroup } from "react-bootstrap";
import MyNavbar from "../component/navbar";
import logo from "../assets/images/logo_large.svg";
import isEmpty from "is-empty";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toastAlert } from "../helper/toastAlert"
import { Roller } from "react-awesome-spinners";
import { login, getUserLocation } from "../ApiAction/api"
import {
  loginValidate, loginInputValidate,
} from "../validation/validation"

let initialData = {
  email: "",
  password: "",
  rememberMe: false
};

export default function Login(props) {
  const [loginData, setLoginData] = useState(initialData);
  const [error, setError] = useState({});
  const [isLoad, setisLoad] = useState(false);
  const [LoginHistory, setLoginHistory] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  let { email, password, rememberMe } = loginData;
  let navigate = useNavigate()

  // useEffect(() => {
  //   const savedEmail = localStorage.getItem("rememberedEmail");
  //   if (savedEmail) {
  //     setLoginData((prevState) => ({
  //       ...prevState,
  //       email: savedEmail, rememberMe: true
  //     }));
  //   }
  //   getUserLogindetails();
  //   getUserLocation()
  // }, []);

  // Fetch user location details
  const getUserLogindetails = async () => {
    try {
      let result = await getUserLocation();
      setLoginHistory(result);
    } catch (err) {
      console.error("Failed to get user location", err);
    }
  };

  let loginChange = (e) => {
    let { name, value, checked } = e.target;
    var fieldValue = name == "rememberMe" ? checked : value
    var resetData = { ...loginData, [name]: fieldValue };
    delete error[name];
    setLoginData(resetData);
    let errMsg = loginInputValidate(resetData, name);
    setError({ ...error, ...errMsg });
  };

  let loginClick = async () => {
    try {
      let errMsg = await loginValidate(loginData);
      setError(errMsg);
      if (isEmpty(errMsg)) {
        setisLoad(true);
        let datas = {
          userData: loginData,
          LoginHistory: LoginHistory,
        };
        let { status, message, success, authToken, errors } = await login(datas);
        if (status === true) {
          toastAlert("success", message, "login");
          setisLoad(false);

          if (rememberMe) {
            localStorage.setItem("rememberedEmail", email);
          } else {
            localStorage.removeItem("rememberedEmail");
          }

          localStorage.setItem("WinChoToken", authToken);
          setLoginData(initialData);
          setTimeout(() => {
            window.location.href = "/dashboard";
            //navigate("/referral")
          }, 100);
        } else if (!isEmpty(errors)) {
          setisLoad(false);
          toastAlert("error", message, "login");
          setError(errors);
          return;
        } else {
          toastAlert("error", message, "login");
          setisLoad(false);
        }
      }
    } catch (err) {
      console.error(err, "Login error");
    }
  };

  console.log(rememberMe, 'rememberMerememberMe')

  return (
    <>
      <MyNavbar />
      <section>
        <Container>
          <div className="join_sec">
            <Row>
              <Col xl="5">
                <div className="reg_form">
                  <p className="join_head">Login</p>
                  <Form.Label className="input_join" htmlFor="inputPassword5">
                    Email / Phone Number
                    {/* Email */}
                  </Form.Label>
                  <Form.Control
                    className="input_text"
                    type="text"
                    id="inputPassword5"
                    placeholder="Enter your email or phone number"
                    // placeholder="Enter your email"
                    aria-describedby="passwordHelpBlock"
                    name="email"
                    value={email}
                    onChange={loginChange}
                  />
                  {error && error.email && (
                    <span style={{ color: "red" }}>{error.email}</span>
                  )}
                  <Form.Group className="mb-4">
                    <Form.Label className="input_join" htmlFor="inputPassword5">
                      Password
                    </Form.Label>
                    <InputGroup className="input_group_box">
                      <Form.Control
                        className=""
                        type={!showPassword ? "password" : "text"}
                        id="inputPassword5"
                        placeholder="Enter your Password"
                        aria-describedby="passwordHelpBlock"
                        name="password"
                        onChange={loginChange}
                        value={password}
                      />
                      {showPassword ?
                        <InputGroup.Text id="basic-addon1"
                          onClick={() => setShowPassword(!showPassword)}><img
                            src={require("../assets/images/eye_open.png")}
                            alt="img"
                            className="img-fluid "
                            width={20}
                            height={20}
                          /></InputGroup.Text> :
                        <InputGroup.Text id="basic-addon1"
                          onClick={() => setShowPassword(!showPassword)}><img
                            src={require("../assets/images/eye_close.png")}
                            alt="img"
                            className="img-fluid "
                            width={20}
                            height={20}
                          /></InputGroup.Text>}
                    </InputGroup>
                    {error && error.password && (
                      <span style={{ color: "red" }}>{error.password}</span>
                    )}
                  </Form.Group>
                  <div className="d-flex justify-content-between">
                    <Form.Check // prettier-ignore
                      type="checkbox"
                      id="custom-switch"
                      label="Remember Me"
                      className="form_join_check"
                      name="rememberMe"
                      checked={rememberMe}
                      onChange={loginChange}
                    />
                    <p className="link_tag">
                      <a href="/forgotpassword" >Forgot password?</a>
                    </p>
                  </div>

                  <Button className="nav_btn mx-auto d-block mt-5" onClick={loginClick}>
                    Login {isLoad && <i className="fas fa-spinner fa-spin"></i>}
                  </Button>
                </div>
              </Col>
              <Col xl="7" className="d-none  d-xl-block">
                <div className="text-center">
                  <img src={logo} alt="img" className="img-fluid mx-auto " />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section >
    </>
  );
}
